module.exports = __webpack_public_path__ + "static/media/CanolaRapeseedIcon.45a9197f.svg";